import React, { ReactNode } from "react";
import { useMandatorVisibility, VisibilityRule } from "./useMandatorVisibility";

interface MandatorConditionalProps extends VisibilityRule {
  children: ReactNode;
}

export const MandatorConditional = ({
  children,
  ...rule
}: MandatorConditionalProps) => {
  const isVisible = useMandatorVisibility(rule);

  if (!isVisible) {
    return null;
  }

  return <>{children}</>;
};
